<template>
  <div id="apply-button">
    <button
      @click="applyRedirect"
      :disabled="!startRecruiting"
      class="font-roboto text-black px-16 py-2 rounded-3xl sm:text-lg"
      :class="{'bg-white': startRecruiting, 'bg-light_grey': !startRecruiting}">
      {{$t("apply.hero.applyButtonText")}}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    startRecruiting: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    applyRedirect() {
      if (!this.startRecruiting) return;
      window.open(
        "https://docs.google.com/forms/d/e/1FAIpQLSfmSPGSL-UGYWwsvpWJ4i33GsegtSO_GgUcLpYhKtM1KCBP2g/viewform?usp=header",
        "_blank",
      );
    },
  },
};
</script>
